import React from 'react'
import PropTypes from 'prop-types'
import {
  CardValue,
  Field,
  Columns,
  LocalizedDateTime,
  LocalizedText,
  LabeledTextarea,
  WithLabel,
  Rows,
} from 'labguard-cdk'
import FormModal from '../FormModal'
import styles from './ChannelAlarmModal.scss'
import AckCommentInput from './AckCommentInput'
import AckComment from './AckComment'
import AlertComments from './AlertComments'

const ChannelAlarmModal = ({ alarm, loading }) => (
  <FormModal loading={loading} className={styles.container} title={<LocalizedText id="WEB_ACKNOWLEDGE_AN_ALARM" />}>
    <WithLabel topLabel={<LocalizedText id="WEB_ALARM_INFORMATION" />} stretch>
      {() => (
        <Rows>
          <Columns>
            <CardValue row title={<LocalizedText id="WEB_PERIOD_FROM" />}>
              <LocalizedDateTime value={alarm.startDate} />
            </CardValue>
            <CardValue row title={<LocalizedText id="WEB_PERIOD_TO" />}>
              <LocalizedDateTime value={alarm.endDate} />
            </CardValue>
          </Columns>
          <CardValue row title={<LocalizedText id="WEB_ALARM_TYPE" />} color={alarm.type && alarm.type.color}>
            {alarm.type && <LocalizedText id={alarm.type.i18n} />}
          </CardValue>
        </Rows>
      )}
    </WithLabel>

    <WithLabel topLabel={<LocalizedText id="WEB_ACKNOWLEDGE_NOTE" />} stretch>
      {() =>
        !alarm.ackComment ? <Field name="ackCommentId" component={AckCommentInput} /> : <AckComment alarm={alarm} />
      }
    </WithLabel>
    {alarm.id && alarm.ackComment && <AlertComments alarmId={alarm.id} />}
    <Field
      name="alertComment"
      component={LabeledTextarea}
      topLabel={<LocalizedText id="WEB_NEW_NOTE" />}
      style={{ minHeight: '10vh' }}
    />
  </FormModal>
)

ChannelAlarmModal.propTypes = {
  loading: PropTypes.bool,
  alarm: PropTypes.shape({
    id: PropTypes.string,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    ackDate: PropTypes.instanceOf(Date),
    type: PropTypes.shape({
      id: PropTypes.string,
      i18n: PropTypes.string,
      color: PropTypes.string,
    }),
    ackComment: PropTypes.any,
  }).isRequired,
}

export default ChannelAlarmModal
